import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { comparisonRows, providers } from '../data/siteData';

const { FiCheck } = FiIcons;

function ComparisonTable({ condensed = false }) {
  const rows = condensed ? comparisonRows.slice(0, 7) : comparisonRows;

  return (
    <div className="table-shell" tabIndex="0" aria-label="Scrollable UCaaS provider comparison">
      <table className="comparison-table">
        <thead>
          <tr>
            <th>Feature</th>
            {providers.map((provider) => <th key={provider}>{provider}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.feature}>
              <th>{row.feature}</th>
              {row.values.map((value, index) => (
                <td key={`${row.feature}-${providers[index]}`}>
                  {value === true ? (
                    <>
                      <SafeIcon icon={FiCheck} aria-hidden="true" />
                      <span className="sr-only">Included</span>
                    </>
                  ) : value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ComparisonTable;